module.exports = __webpack_public_path__ + "static/media/Winning Team.493dc704.pdf";